let Promise = require('bluebird');
let Vue = require('vue');

module.exports = () => new Promise((resolve, reject) => {
    Vue.component("properties_outdated_count", {
        template: `
            <div class="grid-item col-xs-12 col-sm-6 col-md-6 col-lg-3">
                <a class="dashboard-stat dashboard-stat-light widget-desatualizados" v-bind:href="'/properties/search/outdated' | url">
                    <div class="visual">
                        <i class="glyphicon glyphicon-exclamation-sign"></i>
                    </div>
                    <div class="details">
                        <div class="number">
                             {{data.info.count}}
                        </div>
                        <div class="desc">
                             Imóveis desatualizados
                        </div>
                    </div>
                    </a>
            </div>
        `,
        props: ["alias", "data"]
    });

    resolve();
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/widgets/properties_outdated_count.js